export default {
    state: {
        plan: {},
        course: {},
        forum: {}
    },
    mutations: {
        SET_PLAN(state, payload) {
            state.plan = payload
        },
        SET_COURSE(state, payload) {
            state.course = payload
        },
        SET_FORUM(state, payload) {
            state.forum = payload
        }
    },
    getters: {
        PLAN(state) {
            return state.plan
        },
        COURSE(state) {
            return state.course
        },
        FORUM(state) {
            return state.forum
        }
    }
}